<!-- <div style="width: 50%; height: 50%;"
  class="map-container"
  leaflet
  [leafletOptions]="options"
  (leafletMapReady)="onMapReady($event)"
  (leafletMapZoomEnd)="onMapZoomEnd($event)"
></div>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="favoritar()">Favoritar</button>
  <button mat-menu-item (click)="desfavoritar()">Desfavoritar</button>
  <button mat-menu-item (click)="remove()">Remover</button>
</mat-menu>
<div id="circle" [matMenuTriggerFor]="menu"></div> -->

<!-- <div id="map" style="height: 500px;"></div>


<h2>Distance Table</h2>
<table border="1">
  <thead>
    <tr>
      <th>From (Latitude, Longitude)</th>
      <th>To (Latitude, Longitude)</th>
      <th>Distance (km)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let dist of distances">
      <td>{{ dist.point1 }}</td>
      <td>{{ dist.point2 }}</td>
      <td>{{ dist.distance }}</td>
    </tr>
  </tbody>
</table> -->

<div id="map" style="height: 500px; width: 100%;"></div>

<h2>Distance Table</h2>
<table border="1">
  <thead>
    <tr>
      <th>From (City)</th>
      <th>To (City)</th>
      <th>Distance (km)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let dist of distances">
      <td>{{ dist.point1 }}</td>
      <td>{{ dist.point2 }}</td>
      <td>{{ dist.distance }}</td>
    </tr>
  </tbody>
</table>


